export const OPERATION_STATUS = {
  DEFAULT: 0,
  FAIL: 1,
  SUCCESS: 2
};

export const ERROR_DIALOG_DURATION = 5;
export const PREFIX_ERROR_MESSAGE_LENGTH = 2;

export const TIME_TYPE = {
  Year: 'Year',
  Month: 'Month',
  Week: 'Week',
  Past6Months: 'Past6Months'
};

export const UNIT_TYPE = {
  hours: 'hours',
  cleanedSquareMeter: 'cleanedSquareMeter'
};

export const SUBSCRIPTION_MESSAGE_TYPE = {
  CLEANING_REPORT: 'cleaning-report',
  NOTIFICATION: 'notification'
};

export const MAPPING_MACHINE_HEALTH_TEXT = {
  OPTIMAL_CONDITION: 'Optimal condition',
  SERVICE_NEEDED: 'Service needed',
  UNKNOWN: 'Unknown'
};

export const SUBSCRIPTION_MESSAGE_CLASS_NAME = 'subscription-notification';

export const PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [5, 10, 15, 20];

export const DATA_EXPORT_FORM_FIELDS = {
  COLUMNS: 'exportColumns',
  FILE_TYPE: 'exportType'
};

export const DATA_EXPORT_FILE_TYPE = {
  XLSX: 'xlsx',
  PDF: 'pdf'
};

export const LEGAL_COUNTRY_LANGUAGE_CODES = {
  DE: 'DE',
  SV: 'SV',
  SW: 'SW',
  FR_BE: 'fr-BE',
  NL_BE: 'nl-BE',
  PL: 'PL',
  ES: 'ES',
  EN_GB: 'en-GB',
  USA: 'USA'
};

export const LEGAL_COUNTRIES_LANGUAGES = [
  {
    label: LEGAL_COUNTRY_LANGUAGE_CODES.DE,
    value: LEGAL_COUNTRY_LANGUAGE_CODES.DE,
    icon: 'germany'
  },
  {
    label: LEGAL_COUNTRY_LANGUAGE_CODES.SV,
    value: LEGAL_COUNTRY_LANGUAGE_CODES.SV,
    icon: 'sweden'
  },
  {
    label: LEGAL_COUNTRY_LANGUAGE_CODES.SW,
    value: LEGAL_COUNTRY_LANGUAGE_CODES.SW,
    icon: 'switzerland'
  },
  {
    label: LEGAL_COUNTRY_LANGUAGE_CODES.FR_BE,
    value: LEGAL_COUNTRY_LANGUAGE_CODES.FR_BE,
    icon: 'belgium' // french for the people in Belgium country
  },
  {
    label: LEGAL_COUNTRY_LANGUAGE_CODES.NL_BE,
    value: LEGAL_COUNTRY_LANGUAGE_CODES.NL_BE,
    icon: 'belgium' // dutch for the people in Belgium country
  },
  {
    label: LEGAL_COUNTRY_LANGUAGE_CODES.PL,
    value: LEGAL_COUNTRY_LANGUAGE_CODES.PL,
    icon: 'poland'
  },
  {
    label: LEGAL_COUNTRY_LANGUAGE_CODES.ES,
    value: LEGAL_COUNTRY_LANGUAGE_CODES.ES,
    icon: 'spain'
  },
  {
    label: LEGAL_COUNTRY_LANGUAGE_CODES.EN_GB,
    value: LEGAL_COUNTRY_LANGUAGE_CODES.EN_GB,
    icon: 'united-kingdom'
  },
  {
    label: LEGAL_COUNTRY_LANGUAGE_CODES.USA,
    value: LEGAL_COUNTRY_LANGUAGE_CODES.USA,
    icon: 'usa'
  }
];

export const DEFAULT_LEGAL_COUNTRY_LANGUAGE = LEGAL_COUNTRY_LANGUAGE_CODES.DE;

export const SVG_FILE_CONTENT_TYPE = 'image/svg+xml';
